import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import styled from "styled-components";
import PageHeader from "../../components/PageHeader.tsx";
import ActivePrinterComponent from "../../components/ActivePrinterComponent.tsx";
import Scrollbars from "react-custom-scrollbars-2";
import { useQuery } from "@tanstack/react-query";
import { getPrinters } from "../../../services/filamentService.js";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const Content = styled.div`
  box-sizing: border-box;
  background-color: white;
  width: calc(100% - 2rem);
  border-radius: 8px;
  padding: 20px;
  margin-left: 1rem;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
`;

const PrintersManagementLayoutPage: React.FC = () => {
  const navigate = useNavigate();
  const { data: printers, refetch } = useQuery({
    queryKey: ["printers"],
    queryFn: getPrinters,
  });

  return (
    <Wrapper data-testid="printers-management-layout-page">
      <PageHeader
        pageTitle="Management"
        actionButtons={[
          {
            label: "Adaugă imprimantă",
            onClick: () => {
              navigate("printer/new");
            },
            isEmpty: true,
          },
        ]}
      />
      <Scrollbars style={{ width: "100%" }}>
        <ActivePrinterComponent printers={printers} refetch={refetch} />
        <Content data-testid="printers-management-content">
          <Outlet
            context={{
              refetch: refetch,
            }}
          />
        </Content>
      </Scrollbars>
    </Wrapper>
  );
};

export default PrintersManagementLayoutPage;
